@if (showTitle()) {
  <vectronic-filter-header
    (titleClicked)="toggleFilter()"
    [title]="title()"
    [titleTooltip]="titleTooltip()"
    (enabledFilterToggle)="toggleFilter()"
    [isFilterEnabled]="!isFilterHidden()"
  ></vectronic-filter-header>
}
<div class="filter-body" [hidden]="isFilterHidden()">
  <div class="container">
    <mat-form-field appearance="outline" class="filter-field">
      <mat-label>{{ title() }}</mat-label>
      <input
        matInput
        [(ngModel)]="fieldValue"
        (keyup.enter)="confirm()"
        #filterInput
        [placeholder]="placeholder()"
      />
      <div matTooltip="filter is applied" [matTooltipDisabled]="!confirmed()" matSuffix>
        <button
          mat-icon-button
          (click)="confirm()"
          matTooltip="click to apply the filter"
          [disabled]="confirmed()"
          [class.status_confirmed]="confirmed()"
        >
          <mat-icon>check_circle</mat-icon>
        </button>
      </div>
    </mat-form-field>
  </div>
</div>
